import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  toast: {
    position: 'fixed',
    top: 20,
    right: 20,
    zIndex: 9999,
  },
}));

export const ScoreToast = ({
  requestOpen,
  qualityDirection,
  newSpatialLayer,
  previousSpatialLayer,
  score,
  assignedId,
  onClose
}) => {
  const classes = useStyles();
  const [severity, setSeverity] = useState('info');
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  // Function to show the toast
  const showToast = () => {
    setOpen(true);

    // Auto-close after 4 seconds
    setTimeout(() => {
      setOpen(false);
    }, 4000);
  };

  // Function to hide the toast
  const hideToast = () => {
    setOpen(false);
  };

  // Update message when props change
  useEffect(() => {
    if (qualityDirection !== null) {
      if (qualityDirection) {
        setSeverity('success');
        setMessage(`Video stream improved to ${getQualityLabel(newSpatialLayer)} quality.`);
      } else {
        setSeverity('warning');
        setMessage(`Video stream reduced to ${getQualityLabel(newSpatialLayer)} quality.`);
      }
      showToast(); // Automatically show when data changes
    }
  }, [qualityDirection, newSpatialLayer, score]);


  const getQualityLabel = (layer) => {
    switch (layer) {
      case 1: return 'lowest';
      case 2: return 'medium';
      case 3: return 'highest';
      default: return 'unknown';
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      className={classes.toast}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};